import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import Seo from "@/components/Seo";

export const LoginPage = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  React.useEffect(() => {
    if (user && user !== false) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setErrMsg("");
    setSubmitting(true);
    const res = await login(email.trim(), password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Bine ai revenit, Alexia.");
      navigate("/admin");
    } else {
      setErrMsg(res.error || "Autentificare eșuată");
    }
  };

  return (
    <main data-testid="login-page" className="relative mx-auto flex min-h-[80vh] max-w-md items-center px-6 py-16">
      <Seo title="Atelier" noindex />
      <div className="w-full">
        <div className="mb-8">
          <p className="text-xs uppercase tracking-[0.35em] text-[var(--accent)]">Intrare în Atelier</p>
          <h1 className="mt-3 font-serif text-4xl font-light leading-tight text-[#F7F1E8]">
            Bine ai venit înapoi.
          </h1>
          <p className="mt-3 text-sm text-[#F7F1E8]/78">
            Autentifică-te ca să scrii o însemnare nouă, să faci ordine sau să răspunzi la note.
          </p>
        </div>

        <form onSubmit={submit} className="space-y-4 rounded-3xl bg-[#2B1B13] p-8 ring-1 ring-[color-mix(in_srgb,var(--milk)_18%,transparent)]">
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-[#F7F1E8]/78">E-mail</label>
            <input
              data-testid="login-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full rounded-xl border border-[color-mix(in_srgb,var(--milk)_18%,transparent)] bg-[#0D0907] px-4 py-3 text-sm outline-none focus:border-[var(--accent)] focus:ring-2 focus:ring-[var(--tint-pink)]"
              required
              autoComplete="email"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-[#F7F1E8]/78">Parolă</label>
            <input
              data-testid="login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full rounded-xl border border-[color-mix(in_srgb,var(--milk)_18%,transparent)] bg-[#0D0907] px-4 py-3 text-sm outline-none focus:border-[var(--accent)] focus:ring-2 focus:ring-[var(--tint-pink)]"
              required
              autoComplete="current-password"
            />
          </div>

          {errMsg && (
            <p data-testid="login-error" className="text-sm text-red-500">
              {errMsg}
            </p>
          )}

          <button
            type="submit"
            disabled={submitting}
            data-testid="login-submit-btn"
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-[var(--accent)] px-6 py-3 text-xs font-medium uppercase tracking-[0.2em] text-white transition-transform hover:-translate-y-0.5 active:scale-95 disabled:opacity-60"
          >
            <KeyRound className="h-3.5 w-3.5" strokeWidth={1.6} />
            {submitting ? "Se deschide ușa…" : "Intră"}
          </button>
        </form>

        <Link
          to="/"
          className="mt-6 inline-block text-xs uppercase tracking-[0.2em] text-[#F7F1E8]/68 hover:text-[#F7F1E8]"
          data-testid="login-back-link"
        >
          &larr; înapoi la jurnal
        </Link>
      </div>
    </main>
  );
};

export default LoginPage;
